import Reveal from "stimulus-reveal-controller";
Stimulus.register("reveal", Reveal);
